import { Link, useLocation } from 'react-router-dom';
import { useMediaQuery } from '@uidotdev/usehooks';
import { styled } from 'styled-components';
import { motion } from 'framer-motion';
import { routes } from '../routes';
import { theme } from '../styles';
import Logo from './Logo';
import Swapper from './Swapper';
import Banner from './Banner';

const Nav = ({ noAnimate = false }) => {
  const location = useLocation();
  const isWidthLg = useMediaQuery(`only screen and (min-width: ${theme.breakpoints.width.lg})`);
  const isWidthSm = useMediaQuery(`only screen and (min-width: ${theme.breakpoints.width.sm})`);

  const navList = routes.filter(route => !['Home', 'Clients', 'Request'].includes(route.name));

  return (
    <NavWrapper>
      <LogoContainer>
        <LogoWrapper to='/'>
          <Logo
            size={isWidthSm ? '1.25rem' : '3rem'}
            noAnimate={noAnimate}
          />
        </LogoWrapper>
      </LogoContainer>
      <NavLinks>
        {navList.map((route, ind) => (
          <NavLink
            key={route.path}
            to={route.path}
            state={{ keepNav: true }}
            $active={location.pathname.includes(route.path)}
            initial={!noAnimate && theme.fadeIn.initial}
            animate={!noAnimate && theme.fadeIn.animate}
            transition={!noAnimate && theme.fadeIn.transition(theme.delaySm + 0.1 * ind)}
          >
            <Swapper $height={`calc(${theme.sizeH6} + ${theme.spaceSm})`}>{route.name}</Swapper>
          </NavLink>
        ))}
      </NavLinks>
      {isWidthSm && (
        <BannerWrapper to='/request'>
          {isWidthLg && (
            <Banner
              size='sm'
              noAnimate={noAnimate}
            />
          )}
        </BannerWrapper>
      )}
    </NavWrapper>
  );
};

const NavWrapper = styled.div`
  height: var(--nav-height);
  min-height: var(--nav-height);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceMd};

  & > * {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.sm}) {
    display: grid;
    grid-template-columns: 2fr 1fr 2fr;
  }
`;

const NavLinks = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${props => props.theme.spaceXl};
`;

const NavLink = styled(motion(Link))`
  color: ${props => (props.$active ? props.theme.brand : props.theme.mutedColor)};
  text-transform: uppercase;

  border: none;
  border-radius: 0;

  transition: color 0.125s ease-in-out, border-color 0.125s ease-in-out,
    scale 0.125s ease-in-out;

  &:hover {
    color: ${props => props.theme.textColor};
    border-color: ${props => props.theme.textColor};
  }

  &:active {
    scale: 0.95;
  }
`;

const LogoWrapper = styled(Link)`
  width: var(--sidenav-width);
  display: flex;
  justify-content: center;
`;

const LogoContainer = styled.div`
  justify-content: center;

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.sm}) {
    justify-content: start;
  }
`;

const BannerWrapper = styled(Link)`
  justify-content: end;
  & > * {
    margin: 0;
  }
`;

export default Nav;
